// extracted by mini-css-extract-plugin
export default {"toggleSwitch":"ToggleSwitch_toggleSwitch__A6egP","toggleCheckbox":"ToggleSwitch_toggleCheckbox__45H0o","toggleLabel":"ToggleSwitch_toggleLabel__Fc4HG"};